<template>
  <div
    v-if="showQRCodeLink"
    class="mobile-app-stores__qr-block"
    @click="onShowModal"
  >
    <p>
      Кликни на&nbsp;QR-код для сканирования
    </p>

    <div class="qr-block">
      <span
        v-if="!loadImage"
        class="loader-overlay"
      >
        <span class="loader-img" />
      </span>
      <img
        class="popup__content__image"
        :src="qrCodeImageSrc"
        alt="QrCode"
        loading="lazy"
        width="83"
        height="83"
        @load="loadImage = true"
      >
    </div>
    <MobileStoresQRCode
      v-if="showModal"
      ref="mobileStoresQRCode"
      :qr-code-image-src="qrCodeImageSrc"
      @hide="onHideModal"
    />
  </div>
</template>

<script>
import MobileStoresQRCode from './MobileStoresQRCode.vue';
import deviceInfo from '../../helpers/device';

export default {
  name: 'MobileStoresQRBlock',
  components: {
    MobileStoresQRCode,
  },
  props: {
    qrCodeImageSrc: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showModal: false,
    loadImage: false,
  }),
  computed: {
    ...deviceInfo,
    showQRCodeLink() {
      return !(this.isMobile || this.isTablet);
    },
  },
  methods: {
    onShowModal() {
      this.showModal = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'all_client_click_download_app_qr' });
    },
    onHideModal() {
      this.showModal = false;
    },
  },
};
</script>
